import SetData from "@/vuex/SetData";
import i18n from "@/i18n";

let MetaData = function () {

    this.set = function () {

        let desc = SetData.getters.getSet;

        let title;

        if (desc.items.length === 0) {
            title = i18n.t("Empty.metaTitle");
        } else {
            title = desc.summary.title;
        }

        document.title = title;
    };

}

export default new MetaData();